import { createActionGroup, emptyProps, props } from '@ngrx/store'

import {
  AiAgent,
  ContextDocument,
  UploadContextFile,
} from '@flowx/designer/modules/new-ai/common/ai.dictionary'

const errorProps = props<{ statusCode: number; errorMsg?: any }>

export const AiDocumentsActions = createActionGroup({
  source: 'AiDocuments',
  events: {
    loadDocuments: emptyProps(),
    loadDocumentsSuccess: props<{ documents: ContextDocument[] }>(),
    uploadDocuments: props<{ documents: UploadContextFile[] }>(),
    uploadDocumentsSuccess: props<{ documents: ContextDocument[]; pageAgent?: AiAgent }>(),
    uploadDocumentsFailure: errorProps(),
    uploadDocumentSSEStatus: props<{ message: string; subtitle: string }>(),
  },
})
